module.exports = __webpack_public_path__ + "static/media/bateau.0f212dd3.webp";